const Notify = require('./notify')

class Action {
  constructor(action) {
    this.id = action.id || action._id
    this._id = this.id
    this.field = action.field
    this.notify = action.notify ? new Notify(action.notify) : action.notify
    this.description = action.description
    this.types = action.types
    this.component = action.component
    this.dynamic = action.dynamic
    this.dataSource = action.dataSource
  }
}

module.exports = Action
